import React from 'react';
import {HomeGameCardItem, HomeGameFloorItem} from '../home.type';
// import HomeCategory from '@/components/business/home-category/home-category';
// import {goTo} from '@/utils';
import {GameCard2} from './game-card-2';
// import {goToUrl} from '@/common-pages/game-navigate';
// import {NotShowAll} from '@/const/home';

const RenderGameCardSection = ({
  floor,
  screenWidth,
  onPress,
}: {
  floor: HomeGameFloorItem;
  screenWidth: number;
  onPress?: (item: HomeGameCardItem) => void;
}) => {
  //   const {calcActualSize} = useScreenSize();
  const cardWidth = (screenWidth * 110) / 375; // 等比缩放宽度
  const cardHeight = (screenWidth * 156) / 375; // 等比缩放高度
  // console.log('>>>', floor.gamesList);
  return (
    <div className="mb-3">
      <div className="pl-2">
        <div className="flex overflow-x-auto hide-scrollbar">
          <div className="flex flex-row gap-[8px]">
            {floor.gamesList?.map(_v => {
              const v = _v as HomeGameCardItem;
              return (
                <GameCard2
                  key={v.id}
                  item={v}
                  screenWidth={cardWidth}
                  screenHeight={cardHeight}
                  onPress={() => onPress && onPress(v)}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenderGameCardSection;
